import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';

import { FcdSegment, SubTrajectorySegment } from 'app/models/fcd';
import { FcdProviderService } from 'app/services';
import { CbmInputStyle } from 'app/shared/input/cbm-input-style';

@Component({
  selector: 'fcd',
  templateUrl: './fcd.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./fcd.component.scss']
})
export class FcdComponent implements OnInit {
  /*
  Note: This component uses ChangeDetectionStrategy.OnPush
  Which means changes from outside, like 'subTrajectorySegment.segments.splice(1,1)' won't lead to changes!
  Instead, only when the input changes like 'subTrajectorySegment = newSegment' will it lead to changes

  For displaying FCD data on the details pages this is no issue, as it's only ever retrieved and not edited

  Without OnPush this component caused a massive performance issue for large numbers of segments.
  Mouse interactions lead to change detection, for EVERY fcd segment in the DOM
  */

  @Input() subTrajectorySegment: SubTrajectorySegment;
  @Input() index: number;
  @Input() inputStyle: CbmInputStyle;
  @Input() readonly: boolean;

  @ViewChild('body') body: ElementRef;

  @Output() deleteFcdSegement: EventEmitter<number> = new EventEmitter<number>();
  @Output() addFcdSegement: EventEmitter<number> = new EventEmitter<number>();

  public haveError = false;
  public originalSegmentIdError = false;
  public open: boolean;

  constructor(
    private readonly renderer: Renderer2,
    private readonly fcdProviderService: FcdProviderService,
    private readonly ref: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (!this.subTrajectorySegment) {
      this.haveError = true;
      this.addFcdSegement.emit(0);
    } else if (
      this.subTrajectorySegment &&
      this.subTrajectorySegment.fcdSegments &&
      this.subTrajectorySegment.fcdSegments.length === 0
    ) {
      this.haveError = true;
      const fcdSegments = new FcdSegment();
      this.subTrajectorySegment.fcdSegments = [fcdSegments];
    }
  }

  public collapse(open?: boolean): void {
    if (open !== undefined) {
      this.open = open;
      this.ref.markForCheck();
    } else {
      this.open = !this.open;
    }
  }

  public haveMultipleSegments(): boolean {
    return (
      this.subTrajectorySegment &&
      this.subTrajectorySegment.fcdSegments &&
      this.subTrajectorySegment.fcdSegments.length > 1
    );
  }

  public hasStatusManual(): boolean {
    if (this.subTrajectorySegment.manual) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/fcd/fcd.component.ts